import React, { Component } from 'react'
import PropTypes from 'prop-types'

import classnames from 'classnames'
import { Draggable } from 'react-beautiful-dnd'
import Select from 'react-select'

import { getStageElementsByTypes, validateSearchResults } from '../../../functions'

import SelectForm from '../select-form'

import Switch from '../../../common/switch'

class ListEquipment extends Component {
  constructor(props) {
    super(props)

    this.state = {
      required: false,
      showSelectForm: false,
      showTypeSelectForm: false,
      showDropdown: false
    }
  }

  componentWillMount() {
    const { required } = this.props

    this.setState({required})
  }

  componentWillReceiveProps(nextProps) {
    const { required } = nextProps

    if (this.props.required !== required) {
      this.setState({required})
    }
  }

  renderDropdown(item) {
    const { showDropdown } = this.state

    const className = classnames({
      'ui-dropdown': true,
      'ui-dropdown--active': showDropdown
    })

    return (
      <div className={className}>
        {showDropdown === true ? <div className="ui-dropdown-escape" onClick={() => this.setState({showDropdown: !showDropdown})} /> : null}

        <div className="ui-dropdown-handle" onClick={() => this.setState({showDropdown: !showDropdown})} />

        {
          showDropdown === true
          ? <ul className="ui-dropdown-content">
              <li onClick={() => this.setState({showTypeSelectForm: true, showDropdown: false})}>Change type</li>
              <li onClick={() => this.setState({showSelectForm: true, showDropdown: false})}>Rename equipment</li>
              <li onClick={() => this.setState({showDropdown: false}, () => this.props.deleteRiderItem(item.id))}>Remove this equipment</li>
            </ul>
          : null
        }
      </div>
    )
  }

  renderEmptyEquipmentItem(item, parentId, stageElements) {
    const { view } = this.props

    if (view.editable !== true) return null

    return (
      <SelectForm
        group={this.props.group}
        item={{
          class: 'equipment',
          parent: parentId
        }}
        position={0}
        setFocus={true}
        removeFocus={() => this.props.removeRiderItem(item)}
        createRiderColumn={this.props.createRiderColumn}
        createRiderItem={this.props.createRiderItem}
        editRiderItem={this.props.editRiderItem}
        options={this.props.options}
        categories={this.props.categories}
        creatableCategory={true}
        searchResults={validateSearchResults(stageElements)}
        getSearchResults={this.props.getSearchResults} />
    )
  }

  renderEquipmentItem(item, parentId, stageElements) {
    const { view } = this.props

    const renderSelectForm = (item, stageElements) => (
      <SelectForm
        group={this.props.group}
        item={item}
        position={item.children.length+1}
        setFocus={true}
        removeFocus={() => this.setState({showSelectForm: false})}
        createRiderColumn={this.props.createRiderColumn}
        createRiderItem={this.props.createRiderItem}
        editRiderItem={this.props.editRiderItem}
        options={getStageElementsByTypes(['cable', 'insert', 'microphone', 'stand'], stageElements)}
        categories={getStageElementsByTypes(['cable', 'insert', 'microphone', 'stand'], stageElements.groups)}
        creatableCategory={true}
        searchResults={validateSearchResults(stageElements)}
        getSearchResults={this.props.getSearchResults} />
    )

    const renderTypeSelectForm = (item, stageElements) => (
      <div className="select-form select-form--type">
        <div className="select-form-escape" onClick={() => this.setState({showTypeSelectForm: false})} />

        <div className="select-form-fields">
          <Select
            autoFocus={true}
            openOnFocus={true}
            className="select-form-field"
            name={`item-type-selector-${item.id}`}
            value={undefined}
            valueKey="id"
            labelKey="title"
            clearable={false}
            onChange={(selectedItem) => this.setState({showTypeSelectForm: false}, () => this.props.editRiderItem({id: item.id, type: selectedItem.type.slug}))}
            categories={getStageElementsByTypes(['cable', 'insert', 'microphone', 'stand'], stageElements.groups)} />
        </div>
      </div>
    )

    const renderListEquipmentItem = (item, stageElements) => {
      const { required, showTypeSelectForm } = this.state

      return (
        <div className="list-equipment-item">
          <div className="list-equipment-item--title" onClick={() => this.setState({showSelectForm: true})}>{item.title}</div>

          {
            !showTypeSelectForm && view.editable
            ? this.renderDropdown(item)
            : null
          }

          {
            view.editable
            ? !showTypeSelectForm
              ? <div className="list-equipment-item--type" onClick={() => this.setState({showDropdown: !this.state.showDropdown})}>{item.type.title}</div>
              : renderTypeSelectForm(item, stageElements)
            : null
          }

          {
            view.editable
            ? <Switch
                required={required}
                toggleSwitch={(required) => this.setState({required}, () => this.props.editRiderItem({id: item.id, required}))} />
            : item.required
              ? <div>Required</div>
              : <div>Band brings</div>
          }
        </div>
      )
    }

    const { showSelectForm } = this.state

    return (
      <Draggable draggableId={item.id} isDragDisabled={!view.editable} type={`equipment-${parentId}`}>
        {(provided, snapshot) => (
          <div>
            <div className="list-equipment--draggable"
              ref={provided.innerRef}
              style={provided.draggableStyle}
              {...provided.dragHandleProps} >

              {
                showSelectForm && view.editable
                ? renderSelectForm(item, parentId, stageElements)
                : renderListEquipmentItem(item, stageElements)
              }
            </div>

            {provided.placeholder}
          </div>
        )}
      </Draggable>
    )
  }

  render() {
    const { item, parentId, stageElements } = this.props

    return item.id !== undefined
    ? this.renderEquipmentItem(item, parentId, stageElements)
    : this.renderEmptyEquipmentItem(item, parentId, stageElements)
  }
}

ListEquipment.propTypes = {
  view: PropTypes.object,
  group: PropTypes.string,
  item: PropTypes.object,
  createRiderColumn: PropTypes.func,
  removeRiderItem: PropTypes.func,
  createRiderItem: PropTypes.func,
  editRiderItem: PropTypes.func,
  deleteRiderItem: PropTypes.func,
  parentId: PropTypes.string,
  required: PropTypes.bool,
  stageElements: PropTypes.object,
  categories: PropTypes.array,
  options: PropTypes.array,
  getSearchResults: PropTypes.func
}

ListEquipment.defaultProps = {
  view: {},
  group: '',
  item: {},
  createRiderColumn: function() {},
  removeRiderItem: function() {},
  createRiderItem: function() {},
  editRiderItem: function() {},
  deleteRiderItem: function() {},
  parentId: '',
  required: false,
  stageElements: {},
  options: undefined,
  categories: undefined,
  getSearchResults: function() {}
}

export default ListEquipment



// WEBPACK FOOTER //
// ./src/components/rider/rider-input/input-list/list-equipment-item.js